export class AppSettings {    
    //static API_BASE_URL: string = "https://localhost:44311/"; 
    //static API_BASE_URL: string = "http://103.92.121.94:12561/"; 
    //static APP_CUSTOMER_URL = "http://103.92.121.94:12562/"; 
    static RE_CAPTCHA_SITEKEY = "6LdB7zwqAAAAAH-H2f3myhXy6FuOajkhxievaQbf";
    static API_BASE_URL: string = "https://api.kangoexpress.com/"; 
    static APP_CUSTOMER_URL = "https://customer.kangoexpress.com/"; 
}
